export const QUERY_STALE_TIME = 1000 * 60 * 5;
export const QUERY_CACHE_TIME = 1000 * 60 * 10;

export const QUERY_KEYS = {
  FILES: 'files',
  FILE: 'file',
  FILE_IMAGE: 'file_image',
  FILE_NOTES: 'file_notes',
  FILE_FONT: 'file_font',
}